var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "21px",
    viewBox: "0 0 29 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEye") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.4998392,15.3109333 C17.0260207,15.3109333 19.0738954,13.2733394 19.0738954,10.75984 C19.0738954,8.24634056 17.0260207,6.20874667 14.4998392,6.20874667 C11.9736577,6.20874667 9.92578299,8.24634056 9.92578299,10.75984 C9.92578299,13.2733394 11.9736577,15.3109333 14.4998392,15.3109333 Z M28.1947242,10.5859733 C26.2499744,4.56485333 20.7462376,0.51984 14.4998392,0.51984 C8.25344076,0.51984 2.7497576,4.56485333 0.805007813,10.5859733 C0.768718967,10.6987733 0.768718967,10.82096 0.805007813,10.93376 C2.7497576,16.95488 8.25349436,20.9998933 14.4998928,20.9998933 C20.7462912,20.9998933 26.2499744,16.95488 28.1947778,10.93376 C28.231013,10.82096 28.231013,10.6987733 28.1947242,10.5859733 Z M14.4998392,18.72432 C10.0860007,18.72432 6.49522743,15.15152 6.49522743,10.7598933 C6.49522743,6.36826667 10.0860543,2.79546667 14.4998392,2.79546667 C18.9136241,2.79546667 22.504451,6.36826667 22.504451,10.7598933 C22.504451,15.15152 18.9136777,18.72432 14.4998392,18.72432 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Call-incoming---start",
    transform: "translate(-282.000000, -521.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(30.000000, 431.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(25.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(216.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icEye",
    transform: "translate(11.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.000000, -23.000000)",
    id: "colour/light-grey"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 65,
    height: 66
  }))), /*#__PURE__*/React.createElement("g", {
    id: "view",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.777778, 0.466667)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEye);
export default __webpack_public_path__ + "static/media/icEye.76a43975bed054ae96fc212021cbbdb1.svg";
export { ForwardRef as ReactComponent };